module.exports = __webpack_public_path__ + "img/status.5146b717.svg";